import React, { useState } from 'react';

interface EmailListItemProps {
  senderName: string;
  subject: string;
  message: string;
  timestamp: string;
  isRead: boolean;
  statusDotUrl: string;
  onClick?: () => void;
  className?: string;
}

export const EmailListItem: React.FC<EmailListItemProps> = ({
  senderName,
  subject,
  message,
  timestamp,
  isRead,
  statusDotUrl,
  onClick,
  className = ''
}) => {
  const [isChecked, setIsChecked] = useState(false);
  const [isStarred, setIsStarred] = useState(false);

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    setIsChecked(e.target.checked);
  };

  const handleStarClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsStarred(!isStarred);
  };

  // const handleRowClick = () => {
  //   // Handle email row click
  //   console.log(`Opening email from ${senderName}`);
  // };

  return (
    <div 
      className={`email-list-item p-4 border-b border-gray-200 ${isRead ? 'bg-white' : 'bg-blue-50'} ${className}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyPress={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClick?.();
        }
      }}
    >
      <div className="email-content">
        <div className="email-left-section">
          <div className="checkbox-status-container">
            <input
              type="checkbox"
              className="email-checkbox"
              checked={isChecked}
              onChange={handleCheckboxChange}
              aria-label={`Select email from ${senderName}`}
            />
            <img 
              src={statusDotUrl} 
              alt="Status indicator"
              className="status-dot"
            />
          </div>
          <div className="sender-info">
            <img 
              src="https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/8f0cbd81-311f-42e2-b828-736c22d1d02b" 
              alt={`${senderName} profile`}
              className="profile-pic"
            />
            <span className="sender-name">{senderName}</span>
          </div>
        </div>
        <div className="email-subject-message">
          <div className="subject-star-container">
            <button
              className="star-button"
              onClick={handleStarClick}
              aria-label={isStarred ? 'Remove from starred' : 'Add to starred'}
            >
              <img 
                src="https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/1e444acf-3489-40e2-a6ed-ac3f3e257e5c" 
                alt="Star"
                className="star-icon"
              />
            </button>
            <span className="email-subject">{subject}</span>
          </div>
          <span className="email-message">{message}</span>
        </div>
      </div>
      <div className="email-right-section">
        <img 
          src="https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/423dda87-2957-43fd-ad3c-fdef9b949a40" 
          alt="Attachment"
          className="attachment-icon"
        />
        <span className="timestamp">{timestamp}</span>
      </div>
    </div>
  );
};
